export const PROFILE_ROUTING = [
    {
        path: '/tai-khoan.html',
        name: 'profile',
        component: () => import('./Profile.vue'),
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Thông tin tài khoản', icon: 'fa fa-user' },
        ] },
        children: [],
    },
];
